import { useState, useEffect } from 'react'

// Module-level state for synchronization across all countdown instances
let globalTimeLeft = 643 // 10 minutes 43 seconds
let globalListeners: Set<(time: number) => void> = new Set()

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    // Register this component's state setter
    globalListeners.add(setTimeLeft)

    // Start the global timer if not already running
    if (globalListeners.size === 1) {
      const interval = setInterval(() => {
        if (globalTimeLeft > 0) {
          globalTimeLeft--
          globalListeners.forEach((listener) => listener(globalTimeLeft))
        }
      }, 1000)

      return () => {
        clearInterval(interval)
        globalListeners.clear()
      }
    }

    return () => {
      globalListeners.delete(setTimeLeft)
    }
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    minutes,
    seconds,
    timeLeft,
  }
}
